import noop from 'lodash/noop';
import * as React from 'react';
const ModalContext = React.createContext({
    closeOnBackground: false,
    showBackground: false,
    showClose: false,
    onClose: noop,
});
export const useModal = () => React.useContext(ModalContext);
export const ModalProvider = (props) => {
    return React.createElement(ModalContext.Provider, { value: props }, props.children);
};
